export default __webpack_public_path__ + "static/media/nammaseva.20b45dfc.png";